import { Actions, actionsFor, actionTypesFor, FilterActionTypes } from "../filter/filter.actions"
import { FilterableEntities } from "../filter/filter.reducer"

export const types: FilterActionTypes = actionTypesFor(FilterableEntities.Users)
export const actions: Actions = actionsFor(FilterableEntities.Users)
